<p class="flex-row-container">
  <span class="diagnose-issue-type flex-column-container">
    {{ diagnosis.issueType | translate }}
  </span>
  <span class="m-r-5 m-l-5">{{ dashSpacer }}</span>
  <span class="diagnose-description">
    {{ diagnosis.description | translate }}
  </span>
</p>
